import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';
//import {Observable} from 'rxjs/Rx';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';
import {CommonService} from '../common.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {
  
  username = '';
  password = '';
  isUsername = true;
  isPassword = true;
  respObject: any;
  covidUrl = "";
  constructor(@Inject(DOCUMENT) private document: Document,
        private renderer: Renderer2,private router: Router, private _rest: RestapiService,private comserv:CommonService) { }


  ngOnInit(){
    this.covidUrl = this._rest.PROJ_PATH+"/gic_covid";
    // console.log(this.covidUrl)
    this.renderer.addClass(this.document.body, 'bg-dark');
  	const token = localStorage.getItem('userId');
    if (token !== null && token !== undefined) {
      const userRoletok = localStorage.getItem('userRole');
      if(userRoletok=="analyst"){
        //this.router.navigate(['/analyst/dashboard']);
        this.router.navigate(['/analyst/landingpage']);
      } else if(userRoletok=="admin"){
        //this.router.navigate(['/admin/dashboard']); 
        this.router.navigate(['/admin/landingpage']);
      } else if(userRoletok=="ceo"){
        //this.router.navigate(['/ceo/dashboard']);
        this.document.location.href = this._rest.CEO_API_ROUTE+'/auth/loginWithId/'+localStorage.getItem('userId');
      }else if(userRoletok=="compliance"){
        this.router.navigate(['/compliance/consolereports']);
      }
    } else {
      this.router.navigate(['/']);
    }
  }
  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, 'bg-dark');
  }
  goToPd(){
    this.router.navigate(['/dashboard']);
  }
  goToFrgtPsw(){
   this.router.navigate(['/forgotpassword']); 
  }


   /** The Window object from Document defaultView */
  get window(): Window { return this.document.defaultView; }
  login() {
    let errCounter = 0;
    if (this.username === '') {
      this.isUsername = false;
      errCounter++;
    } else {
      this.isUsername = true;
    }
    if (this.password === '') {
      this.isPassword = false;
      errCounter++;
    } else {
      this.isPassword = true;
    }
    if(errCounter>0){
      return false;
    }
    const data = {
      userId: this.username,
      password: this.password
    }
    const fd = new FormData();
    fd.append('uName', this.username);
    fd.append('uPass', this.password);
    
    
    this._rest.signIn(data).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.id !== undefined) {
        localStorage.setItem('userId', this.respObject.id);
        localStorage.setItem('userName', this.username);
        localStorage.setItem('userRole', this.respObject.role);
        localStorage.setItem('companyId', this.respObject.companyId);
        localStorage.setItem('companyName', this.respObject.companyName);
        localStorage.setItem('companyLogo', this.respObject.companyLogo);
        localStorage.setItem('peerId', this.respObject.peerId);
        this.comserv.setLastLoginTime();
        if(this.respObject.role=="analyst"){
          this.router.navigate(['/analyst/landingpage']);
        } else if(this.respObject.role=="admin"){
          this.router.navigate(['/admin/landingpage']);
        } else if(this.respObject.role=="ceo"){
          this.document.location.href = this._rest.CEO_API_ROUTE+'/auth/loginWithId/'+localStorage.getItem('userId');
        } else if(this.respObject.role=="compliance"){
          this.router.navigate(['/compliance/consolereports']);
        }
      } else{
        alert("Please enter the valid username or password");
      }
    })

  }

}
